module.exports = __webpack_public_path__ + "static/media/icoke-desktop.8f92e38c.jpg";